import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["content", "chevron", "header"]
  static values = {
    collapsed: { type: Boolean, default: true }
  }

  connect() {
    // Set initial state
    if (this.collapsedValue) {
      this.collapse(false) // false = no animation
    } else {
      this.expand(false)
    }
  }

  toggle(event) {
    if (event) {
      // Ignore clicks that land on an interactive control nested inside the
      // header (e.g. admin action buttons or the delete form). Calling
      // preventDefault() on the bubbled click would cancel their native
      // behavior — most notably swallowing the delete form's submission.
      const control = event.target.closest("a, button, form, input, select, [data-reflex]")
      if (control && control !== event.currentTarget) {
        return
      }

      event.preventDefault()
    }

    if (this.collapsedValue) {
      this.expand(true)
    } else {
      this.collapse(true)
    }
  }

  expand(animate = true) {
    this.collapsedValue = false

    if (animate) {
      this.contentTarget.style.height = '0px'
      this.contentTarget.style.opacity = '0'

      // Force reflow
      this.contentTarget.offsetHeight

      // Temporarily enable transitions
      this.contentTarget.style.transition = 'height 0.3s ease-in-out, opacity 0.3s ease-in-out'

      // Get the actual content height
      this.contentTarget.style.height = 'auto'
      const height = this.contentTarget.scrollHeight
      this.contentTarget.style.height = '0px'

      // Trigger animation
      requestAnimationFrame(() => {
        this.contentTarget.style.height = `${height}px`
        this.contentTarget.style.opacity = '1'
      })

      // Clean up after animation
      setTimeout(() => {
        this.contentTarget.style.height = 'auto'
        this.contentTarget.style.transition = ''
      }, 300)
    } else {
      this.contentTarget.style.height = 'auto'
      this.contentTarget.style.opacity = '1'
    }

    // Rotate chevron
    if (this.hasChevronTarget) {
      this.chevronTarget.style.transform = 'rotate(180deg)'
    }

    // Update header classes
    if (this.hasHeaderTarget) {
      this.headerTarget.classList.remove('border-b-0')
      this.headerTarget.classList.add('border-b-2')
    }
  }

  collapse(animate = true) {
    this.collapsedValue = true

    if (animate) {
      // Get current height
      const height = this.contentTarget.scrollHeight
      this.contentTarget.style.height = `${height}px`

      // Force reflow
      this.contentTarget.offsetHeight

      // Enable transitions
      this.contentTarget.style.transition = 'height 0.3s ease-in-out, opacity 0.3s ease-in-out'

      // Trigger animation
      requestAnimationFrame(() => {
        this.contentTarget.style.height = '0px'
        this.contentTarget.style.opacity = '0'
      })

      // Clean up after animation
      setTimeout(() => {
        this.contentTarget.style.transition = ''
      }, 300)
    } else {
      this.contentTarget.style.height = '0px'
      this.contentTarget.style.opacity = '0'
    }

    // Rotate chevron back
    if (this.hasChevronTarget) {
      this.chevronTarget.style.transform = 'rotate(0deg)'
    }

    // Update header classes
    if (this.hasHeaderTarget) {
      this.headerTarget.classList.remove('border-b-2')
      this.headerTarget.classList.add('border-b-0')
    }
  }
}
